import(/* webpackMode: "eager" */ "C:\\githubrunners\\runnerweb\\_work\\minthr-client-front\\minthr-client-front\\src\\app\\not-found.tsx");
